import { Dialog, Box, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ZoomModal = ({ zoomOpen, onZoomClose, imageSrc, altText}) => (
      <Dialog open={zoomOpen} onClose={onZoomClose} fullScreen disablePortal>
        <Box position="fixed" display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <IconButton
            onClick={onZoomClose}
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={imageSrc}
            alt={altText}
            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Dialog>);

export default ZoomModal;